// eslint-disable-next-line import/prefer-default-export
export const VIOLATIONS_ACTIONS = {
  REPORTED: 'REPORTED',
  VALIDATED: 'VALIDATED',
  REVOKED: 'REVOKED',
  DISPUTED: 'DISPUTED',
  ESCALATED: 'ESCALATED',
  IN_REVIEW: 'IN_REVIEW',
}
